export default __webpack_public_path__ + "static/media/icon_expand.e4520ed7.svg";